import { isEmpty, get } from 'lodash'
import http, { setHttpToken } from '@/http'

export default {
  auth: {
    state: () => ({
      user: null,
      token: null
    }),

    getters: {
      authenticated(state) {
        return !!state.token
      },

      client(state) {
        return get(state.user, 'client')
      },

      manager(state) {
        return get(state.user, 'manager')
      }
    },

    mutations: {
      login(state, { token, user }) {
        state.user = user
        state.token = token

        setHttpToken(state.token)
      },

      logout(state) {
        state.user = null
        state.token = null

        setHttpToken(state.token)
      },

      setUser(state, user) {
        state.user = user
      },

      setToken(state, token) {
        state.token = token
        setHttpToken(token)
      },

      setClient(state, client) {
        if (null !== state.user) {
          state.user.client = client
        }
      },

      setManager(state, manager) {
        if (null !== state.user) {
          state.user.manager = manager
        }
      }
    },

    actions: {
      agreeToOffer({ state, commit }, uRoleCode) {
        return http.post(`auth/agreeToOffer/${uRoleCode}`).then(() => {
          const uRoles = get(state, 'user.user_roles', [])
          for (const [index, role] of uRoles.entries()) {
            if (role.role_code === uRoleCode) {
              uRoles[index].agreement_required = false
              const updUser = Object.assign(state.user, { user_roles: uRoles })
              commit('setUser', updUser)
              break
            }
          }
        })
      },

      login({ commit }, credentials) {
        return http.post('/auth/login', credentials).then(response => {
          commit('login', response.data)
          return response.data
        })
      },

      logout({ commit }) {
        return http.post('/auth/logout').finally(() => {
          commit('logout')
        })
      },

      invalidateUser({ commit }) {
        return http.post('/auth/details').then(response => {
          commit('setUser', response.data)
          return response.data
        })
      },

      /**
       * TODO: проверить работу этих вызовов
       */
      resetPassword(context, payload) {
        return http.post('/auth/reset/password', payload)
      },

      resetConfirm(context, payload) {
        let action = isEmpty(payload.phone) ? 'email' : 'phone'
        return http.post(`/auth/confirm/${action}/reset`, payload)
      },

      register(context, payload) {
        return http.post('/auth/register', payload)
      },

      confirm(context, payload) {
        let action = isEmpty(payload.phone) ? 'email' : 'phone'
        return http.post(`/auth/confirm/${action}`, payload)
      },
      refreshToken({ commit, getters, state }) {
        if (!getters.authenticated) {
          return Promise.reject({
            error: 'Пользователь не авторизован'
          })
        }

        return http
          .get('auth/reset/token', {
            params: {
              token: state.token
            }
          })
          .then(response => {
            if ('success' === response.status) {
              commit('setToken', response.new_token)
              return Promise.resolve(response)
            }

            return Promise.reject(response)
          })
      }
    },

    namespaced: true
  }
}
